import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { CompetencyLevelsPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { CompetencyLevelsReorderModal } from 'modules/competencies/components/CompetencyLevelsReorderModal'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { CompetencyLevelsDataCollection } from './LevelsDataCollection'

const CompetencyLevels = () => {
  const { competencyId } = useParams<{ competencyId: string }>()
  const [showReorderLevels, setShowReorderLevels] = useState<boolean>(false)

  const { data, loading, error } = useQuery(CompetencyLevelsPageDocument, {
    variables: {
      id: Number(competencyId),
    },
  })

  const competency = data?.competencies?.competency

  const canManageCompetencyLevels = data?.competencies?._policies?.competenciesManage?.can || false

  return (
    <ResponsivePage.Body variant="narrow" loading={loading} error={error}>
      {competency && (
        <CompetencyLevelsDataCollection
          competency={competency}
          canManageCompetencyLevels={canManageCompetencyLevels}
          onReorderLevels={() => setShowReorderLevels(true)}
        />
      )}

      {showReorderLevels && (
        <CompetencyLevelsReorderModal
          competencyId={Number(competencyId)}
          onClose={() => setShowReorderLevels(false)}
          onSuccess={() => setShowReorderLevels(false)}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default CompetencyLevels
